import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full min-h-full bg-white" }
const _hoisted_2 = { class: "flex w-full" }
const _hoisted_3 = { class: "w-full px-6 md:pl-0 md:pr-4 overflow-x-auto" }
const _hoisted_4 = { id: "main-content" }
const _hoisted_5 = { class: "pb-12 mx-auto sm:pl-6 lg:pl-8" }

import { storeToRefs } from "pinia";

import NavigationBar from "@/components/NavigationBar.vue";
import BreadCrumbs from "@/components/BreadCrumbs.vue";
import SideBar from "@/components/SideBar.vue";

import { useGlobalStore, useUserStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  async setup(__props) {

let __temp: any, __restore: any

const globalStore = useGlobalStore();
const userStore = useUserStore();

const { user } = storeToRefs(userStore);

;(
  ([__temp,__restore] = _withAsyncContext(() => Promise.all([globalStore.fetchCourseTypes(), globalStore.fetchUserRoles(), globalStore.fetchCountries(), globalStore.fetchLanguages()]))),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(user).id)
      ? (_openBlock(), _createBlock(NavigationBar, {
          key: 0,
          user: _unref(user)
        }, null, 8, ["user"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_unref(user).id)
        ? (_openBlock(), _createBlock(SideBar, {
            key: 0,
            user: _unref(user)
          }, null, 8, ["user"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("main", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(BreadCrumbs),
            _createVNode(_component_RouterView)
          ])
        ])
      ])
    ])
  ]))
}
}

})